export { default } from './productCard';
